.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  background: url('../../assets/images/background-grid.webp') top center / 100% 80% no-repeat;
}

.searchContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border-radius: 11px;
  border-color: #ffa10033;
  border-width: 2px;
  border-style: solid;
}

.menuLogo {
  width: 25px;
  height: 25px;
}

.title {
  margin-top: 24px;
  font-size: 36px;
  line-height: 52px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #04051b;
}

.message {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  line-height: 24px;
  color: #525252;
  white-space: pre-line;
}

.buttonContainer {
  margin-top: 48px;
  display: flex;
  flex-direction: column-reverse;
  width: 100vw;
  gap: 12px;
  padding: 0 24px;
}

.buttonWrapperBack {
  background-color: #fef5e7;
}

@media (min-width: 900px) {
  .container {
    background: url('../../assets/images/background-grid.webp') top center / 60% 75% no-repeat;
  }

  .title {
    font-size: 66px;
    line-height: 130px;
  }

  .message {
    font-size: 20px;
    line-height: 30px;
  }

  .buttonContainer {
    margin-top: 48px;
    display: flex;
    gap: 12px;
    flex-direction: row;
    width: auto;
  }

  .buttonWrapperBack {
    min-width: 154px;
  }

  .buttonWrapperHome {
    min-width: 154px;
  }
}
